<kendo-dialog-titlebar>
    Encounter Filters
</kendo-dialog-titlebar>
<!-- @if(loadSpinner){
<div class="k-d-flex k-w-full k-justify-content-center">
    <kendo-loader type="converging-spinner" size="medium"></kendo-loader>
</div>
} -->
<!-- @if(!loadSpinner && form){ -->
<!-- <form [formGroup]="form">
    <div class="k-d-grid k-gap-y-lg">
    </div>
</form> -->
<!-- } -->

<div class="k-d-grid k-gap-y-xl">
    <form [formGroup]="allEncounterFiltersForm">
        <section>
            <h5>Student</h5>
            <div class="k-d-grid k-gap-y-xl">
                <div class="k-d-flex k-gap-x-lg">
                    <kendo-formfield class="k-w-full">
                        <kendo-floatinglabel text="Student Name">
                            <kendo-textbox [clearButton]="true" formControlName="studentName"></kendo-textbox>
                        </kendo-floatinglabel>
                    </kendo-formfield>
                    <kendo-formfield class="k-w-full">
                        <kendo-floatinglabel text="Student ID">
                            <kendo-textbox formControlName="studentId"></kendo-textbox>
                        </kendo-floatinglabel>
                    </kendo-formfield>
                </div>
                <div class="k-d-flex k-gap-x-lg">
                    <kendo-formfield class="k-w-full">
                        <kendo-floatinglabel text="Student Type">
                            <kendo-dropdownlist placeholder='Student Type' [valueField]="'id'"
                                [data]="referenceStore?.studentType$ | async" formControlName="studentType"
                                [textField]="'description'"></kendo-dropdownlist>
                        </kendo-floatinglabel>
                    </kendo-formfield>
                    <kendo-formfield class="k-w-full">
                        <kendo-label text="Date of Birth">
                            <kendo-datepicker calendarType="classic" formControlName="dateOfBirth"
                                placeholder="MM/DD/YYYY" [format]="format"></kendo-datepicker>
                        </kendo-label>
                    </kendo-formfield>
                </div>
            </div>
        </section>
        <span class="k-form-separator !k-my-8"></span>
        <section>
            <h5>Mandate Attributes</h5>
            <div class="k-d-grid k-gap-y-xl">
                <div class="k-d-flex k-gap-x-lg">
                    <kendo-formfield class="k-w-full">
                        <kendo-floatinglabel text="Service Type">
                            <kendo-dropdownlist placeholder='Service Type' [valueField]="'id'"
                                [data]="referenceStore.rServiceType$ | async" formControlName="serviceType"
                                [textField]="'description'"></kendo-dropdownlist>
                        </kendo-floatinglabel>
                    </kendo-formfield>
                    <kendo-formfield class="k-w-full">
                        <kendo-floatinglabel text="Language">
                            <kendo-dropdownlist placeholder='Service Type' [valueField]="'id'"
                                formControlName="language" [data]="referenceStore?.language$ | async"
                                [textField]="'description'"></kendo-dropdownlist>
                        </kendo-floatinglabel>
                    </kendo-formfield>
                </div>
                <div class="k-d-flex k-gap-x-lg">
                    <kendo-formfield class="k-w-full">
                        <kendo-floatinglabel text="Frequency">
                            <kendo-dropdownlist [valueField]="'id'" [textField]="'description'"
                                [data]="referenceStore.frequencyNumber$ | async"
                                formControlName="frequency"></kendo-dropdownlist>
                        </kendo-floatinglabel>
                    </kendo-formfield>
                    <kendo-formfield class="k-w-full">
                        <kendo-floatinglabel text="Duration">
                            <kendo-dropdownlist [valueField]="'id'" [textField]="'description'"
                                [data]="referenceStore.hoursDuration$ | async"
                                formControlName="duration"></kendo-dropdownlist>
                        </kendo-floatinglabel>
                    </kendo-formfield>
                </div>
                <div class="k-d-flex k-gap-x-lg">
                    <kendo-formfield class="k-w-full">
                        <kendo-floatinglabel text="Group Size">
                            <kendo-dropdownlist [valueField]="'id'" [textField]="'description'"
                                [data]="referenceStore.groupSize$ | async"
                                formControlName="groupSize"></kendo-dropdownlist>
                        </kendo-floatinglabel>
                    </kendo-formfield>
                    <kendo-formfield class="k-w-full">
                        <kendo-floatinglabel text="Mandate Term">
                            <kendo-dropdownlist placeholder='Duration' [valueField]="'description'"
                                formControlName="mandateTerm" [data]="referenceStore.mandateTerm$ | async"
                                [textField]="'description'"></kendo-dropdownlist>
                        </kendo-floatinglabel>
                    </kendo-formfield>
                </div>
            </div>
        </section>
        <span class="k-form-separator !k-my-8"></span>
        <section>
            <h5>Encounter Attributes</h5>
            <div class="k-d-grid k-gap-y-xl">
                <div class="k-d-flex k-gap-x-lg">
                    <kendo-formfield class="k-w-full">
                        <kendo-floatinglabel text="Encounter Type">
                            <kendo-dropdownlist [textField]="'description'"
                                [data]="referenceStore.rEncounterType$ | async"
                                formControlName="encounterType"></kendo-dropdownlist>
                        </kendo-floatinglabel>
                    </kendo-formfield>
                    <kendo-formfield class="k-w-full">
                        <kendo-floatinglabel text="Status">
                            <kendo-dropdownlist [valuePrimitive]="true" [valueField]="'description'"
                                [textField]="'description'" [data]="encounterStatusList"
                                formControlName="status"></kendo-dropdownlist>
                        </kendo-floatinglabel>
                    </kendo-formfield>
                </div>
                <div class="k-d-flex k-gap-x-lg">
                    <kendo-formfield class="k-w-1/2">
                        <kendo-floatinglabel text="Sort by">
                            <kendo-dropdownlist [valuePrimitive]="true" [valueField]="'id'" [textField]="'description'"
                                [data]="sortDropdown" formControlName="sortBy"></kendo-dropdownlist>
                        </kendo-floatinglabel>
                    </kendo-formfield>
                </div>
                <div class="k-d-flex k-gap-x-lg k-mt-3">
                    <kendo-formfield class="k-w-full">
                        <kendo-label text="Scheduled Date">
                            <kendo-datepicker calendarType="classic" formControlName="scheduledDate"
                                placeholder="MM/DD/YYYY" [format]="format"></kendo-datepicker>
                        </kendo-label>
                    </kendo-formfield>
                    <kendo-formfield class="k-w-full">
                        <kendo-label text="Scheduled Start Time">
                            <kendo-timepicker formControlName="scheduledStartTime"></kendo-timepicker>
                        </kendo-label>
                    </kendo-formfield>
                </div>
                <div class="k-d-flex k-gap-x-lg">
                    <kendo-formfield class="k-w-full">
                        <kendo-floatinglabel text="Scheduled Duration">
                            <kendo-textbox [clearButton]="true" formControlName="scheduledDuration">
                                <ng-template kendoTextBoxSuffixTemplate>
                                    <button kendoButton [disabled]="true">minutes</button>
                                </ng-template>
                            </kendo-textbox>
                        </kendo-floatinglabel>
                    </kendo-formfield>
                    <kendo-formfield class="k-w-full">
                        <kendo-floatinglabel text="Location">
                            <kendo-dropdownlist [valueField]="'value'" [textField]="'text'"
                                [valuePrimitive]="true" [data]="locationFilterOptions"
                                formControlName="location"></kendo-dropdownlist>
                        </kendo-floatinglabel>
                    </kendo-formfield>
                </div>
                <div class="k-d-flex k-gap-x-lg">
                    <kendo-formfield class="k-w-1/2">
                        <kendo-label text="Actual Service Date">
                            <kendo-datepicker calendarType="classic" formControlName="actualServiceDate"
                                placeholder="MM/DD/YYYY" [format]="format"></kendo-datepicker>
                        </kendo-label>
                    </kendo-formfield>
                </div>
            </div>
        </section>
        <span class="k-form-separator !k-my-8"></span>
        <section>
            <h5>Provider</h5>
            <div class="k-d-grid k-gap-y-xl">
                <div class="k-d-flex k-gap-x-lg">
                    <kendo-formfield class="k-w-full">
                        <kendo-floatinglabel text="Provider Name">
                            <kendo-combobox [valueField]="'providerName'" [textField]="'providerName'" [valuePrimitive]="true"
                                [data]="uniqueProviderNames" formControlName="providerName"></kendo-combobox>
                            <ng-template kendoComboBoxItemTemplate let-dataItem>
                                <span>{{ dataItem.providerName }} ({{dataItem.providerId}})</span>
                            </ng-template>
                        </kendo-floatinglabel>
                    </kendo-formfield>
                    <kendo-formfield class="k-w-full">
                        <kendo-floatinglabel text="Provider ID">
                            <kendo-textbox formControlName="providerId">

                            </kendo-textbox>
                        </kendo-floatinglabel>
                    </kendo-formfield>
                </div>
                <div>
                    <kendo-formfield class="k-w-full">
                        <kendo-floatinglabel text="Provider Title">
                            <kendo-dropdownlist [valueField]="'providerTitle'" [textField]="'providerTitle'" [valuePrimitive]="true"
                                [data]="providerList" formControlName="providerTitle"></kendo-dropdownlist>
                        </kendo-floatinglabel>
                    </kendo-formfield>
                </div>
            </div>
        </section>
    </form>
</div>

<kendo-dialog-actions>
    <div class="k-d-flex k-justify-content-between">
        <button kendoButton themeColor="dark" fillMode="outline" (click)="clearFilters()">Clear Filters</button>
        <button kendoButton themeColor="primary" (click)="onFilter()">Show Results</button>
    </div>
</kendo-dialog-actions>